<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-11 10:53:37
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-14 14:49:58
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\drCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="font-h6-regular pl-16 pr-8" style="width: 156px">
		<div>
			<div class="flex-row-align-center yx-color-text-primary">
				<!-- <yx-avatar class="flex-shrink" :size="20" :src="row.head" /> -->
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.partner_role_name">
					<span class="line-ellipsis ml-4" style="max-width: 60px">{{ row.partner_role_name | formatEmpty }}</span>
				</el-tooltip>
				<span>（达人商务）</span>
			</div>
		</div>
	</div>
</template>
<script>
import { drRoleType } from '@/utils/dataMap';

export default {
	components: {
		
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		drName() {
			return drRoleType.name;
		},
	},
	data() {
		return {};
	},
};
</script>